module.exports = __webpack_public_path__ + "img/footer-text.d7746dab.png";